import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class CheckOutboundItemTable extends Component {

    showDataTable = (idInboundStocker, inboundItem, idOutboundStocker, outboundItem) => {
        let options = {
            noDataText: 'No items registered. Try one-lah!',
            sizePerPageList: [{
                text: '10', value: 10
            },{
                text: '25', value: 25
            },{
                text: '50', value: 50
            }],
            sizePerPage: 20,
            btnGroup: this.customBtnGroup,
        };
        return(
            <React.Fragment>
                {idInboundStocker?
                    <React.Fragment>
                        <BootstrapTable data={inboundItem} version="4" striped hover pagination search edit options={options} exportCSV={false} csvFileName={this.fileNameFormat} multiColumnSearch>
                            <TableHeaderColumn dataField="id" isKey dataSort csvHeader="ID" searchable={false} hidden>ID</TableHeaderColumn>
                            <TableHeaderColumn dataField="item_name" searchable dataSort csvHeader="Item Name" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Item Name</TableHeaderColumn>
                            <TableHeaderColumn dataField="batch_number" searchable dataSort csvHeader="Batch Number" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Batch Number</TableHeaderColumn>
                            <TableHeaderColumn dataField="realization_qty" searchable dataSort csvHeader="Delivered Qty" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Delivered Qty</TableHeaderColumn>
                            <TableHeaderColumn dataField="production_date" searchable dataSort csvHeader="Production Date" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Production Date</TableHeaderColumn>
                            <TableHeaderColumn dataField="expired_date" searchable dataSort csvHeader="Expired Date" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Expiry</TableHeaderColumn>
                        </BootstrapTable>
                    </React.Fragment>
                    : null    
                }
                {idOutboundStocker?
                        <React.Fragment>
                          <BootstrapTable data={outboundItem} version="4" striped hover pagination search edit options={options} exportCSV={false} csvFileName={this.fileNameFormat} multiColumnSearch>
                              <TableHeaderColumn dataField="id" isKey dataSort csvHeader="ID" searchable={false} hidden>ID</TableHeaderColumn>
                              <TableHeaderColumn dataField="item_name" searchable dataSort csvHeader="Item Name" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Item Name</TableHeaderColumn>
                              <TableHeaderColumn dataField="batch_number" searchable dataSort csvHeader="Batch Number" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Batch Number</TableHeaderColumn>
                              <TableHeaderColumn dataField="realization_qty" searchable dataSort csvHeader="Delivered Qty" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Delivered Qty</TableHeaderColumn>
                              <TableHeaderColumn dataField="production_date" searchable dataSort csvHeader="Production Date" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Production Date</TableHeaderColumn>
                              <TableHeaderColumn dataField="expired_date" searchable dataSort csvHeader="Expired Date" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Expiry</TableHeaderColumn>
                          </BootstrapTable>
                      </React.Fragment>
                    : null
                }
            </React.Fragment>
        )
    }

    render(){
        const {idInboundStocker, idOutboundStocker,
                outboundItem, inboundItem, showTable} = this.props
        return(
            <React.Fragment>
                <br />
                {showTable?
                    <Row>
                        <Col md="12" xs="12">
                            {this.showDataTable(idInboundStocker, inboundItem, idOutboundStocker, outboundItem)} 
                        </Col>
                    </Row>
                    : 
                    null
                }
            </React.Fragment>
        )
    }

}

export default CheckOutboundItemTable;


// WEBPACK FOOTER //
// ./src/views/Widgets/CheckOutboundItemTable.jsx